import React from 'react';
import logo from '../assests/logo.png';
import '../static/css/app.css';
import {Link} from "react-router-dom";

import * as PoweredBy from '../assests/poweredby-logo_transparent.png';

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <footer id="footer" className="container-fluid">
                <div id="footer-detail" className="row justify-content-between">
                    <div className="footer-col col-sm-12 col-md-4 d-flex">
                        <img src={logo} alt="Logo" id="flogo" height="60" width="60"/>
                        <div className="text-left">
                            <h4 className="mb-0 ml-0">euBines</h4>
                            <small>&copy; Copyright 2019</small>
                        </div>
                    </div>
                    <div className="footer-col col-sm-12 col-md-4" style={{textAlign: 'left'}}>
                        <h4>About Us</h4>
                        <div>
                            <Link to='/'>About euBines</Link><br/>
                            <Link to='/become-partner'>Become a Partner/Investor</Link>
                        </div>
                        <div className="py-2">
                            <p>Donate to Team</p>
                            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                                <input type="hidden" name="cmd" value="_s-xclick"/>
                                <input type="hidden" name="hosted_button_id" value="UXQ2J4YG5ZX8Q"/>
                                <input type="image"
                                       src="https://www.paypalobjects.com/en_US/GB/i/btn/btn_donateCC_LG.gif" border="0"
                                       name="submit" title="PayPal - The safer, easier way to pay online!"
                                       alt="Donate with PayPal button"/>
                                <img alt="" border="0" src="https://www.paypal.com/en_GB/i/scr/pixel.gif" width="1"
                                     height="1"/>
                            </form>

                        </div>
                    </div>
                    <div className="footer-col col-sm-12 col-md-4" style={{float: "right", textAlign: 'left'}}>
                        {/*<a href="">Location Map</a> <br></br>*/}
                        <a href="">Popular</a> <br/>
                        <a href="">Term and use</a> <br/>
                        <a href="">Help & Contact Us</a>
                    </div>
                </div>
                <hr/>
                <br/>
                <div className="row">
                    <div className="col">
                        <div className=" footer-social">
                            Follow euBines
                            <div className="d-flex justify-content-center">
                                <a className="px-2" href="https://www.facebook.com/EuBines-382391225699581">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
                                        <path fill="#rrrr" className="st0"
                                              d="M35.3,17.7C35.3,7.9,27.4,0,17.7,0S0,7.9,0,17.7c0,8.8,6.5,16.1,14.9,17.4V22.8h-4.5v-5.1h4.5l0-3.9c0-4.4,2.6-6.9,6.7-6.9c1.9,0,3.9,0.4,3.9,0.4v4.3h-2.2c-2.2,0-2.9,1.4-2.9,2.8l0,3.3h4.9l-0.8,5.1h-4.1v12.3C28.8,33.8,35.3,26.5,35.3,17.7z"/>
                                    </svg>
                                </a>
                                <a className="px-2" href="https://www.instagram.com/eubinesdotcom/">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                        <path
                                            d="M21.93,6.47a8.06,8.06,0,0,0-.51-2.68,5.32,5.32,0,0,0-1.27-1.94A5.32,5.32,0,0,0,18.21.58,8,8,0,0,0,15.54.07C14.36,0,14,0,11,0S7.64,0,6.47.07A8.06,8.06,0,0,0,3.79.58,5.32,5.32,0,0,0,1.85,1.85,5.32,5.32,0,0,0,.58,3.79,8.06,8.06,0,0,0,.07,6.47C0,7.64,0,8,0,11s0,3.36.07,4.53a8.06,8.06,0,0,0,.51,2.68,5.35,5.35,0,0,0,1.27,1.95,5.42,5.42,0,0,0,1.94,1.26,8.06,8.06,0,0,0,2.68.51C7.64,22,8,22,11,22s3.36,0,4.54-.07a8,8,0,0,0,2.67-.51,5.67,5.67,0,0,0,3.21-3.21,8.06,8.06,0,0,0,.51-2.68C22,14.36,22,14,22,11S22,7.64,21.93,6.47Zm-2.09,8.92a6.11,6.11,0,0,1-.37,2,3.57,3.57,0,0,1-2.06,2.06,6.11,6.11,0,0,1-2,.37c-1.15.05-1.49.07-4.39.07s-3.24,0-4.39-.07a6.11,6.11,0,0,1-2-.37,3.57,3.57,0,0,1-2.06-2.06,6.11,6.11,0,0,1-.37-2C2.11,14.24,2.1,13.9,2.1,11s0-3.24.06-4.39a6.11,6.11,0,0,1,.37-2,3.55,3.55,0,0,1,.81-1.25,3.6,3.6,0,0,1,1.25-.81,6.11,6.11,0,0,1,2-.37C7.76,2.11,8.1,2.09,11,2.09s3.24,0,4.39.07a6.11,6.11,0,0,1,2,.37,3.57,3.57,0,0,1,2.06,2.06,6.11,6.11,0,0,1,.37,2c.05,1.15.07,1.49.07,4.39S19.9,14.24,19.84,15.39Z"
                                            fill="#rrrr" fillRule="evenodd"/>
                                        <path
                                            d="M18.33,5a1.29,1.29,0,0,0-1.25-1.36,1.31,1.31,0,0,0-1.37,1.25V5a1.31,1.31,0,0,0,1.37,1.25A1.29,1.29,0,0,0,18.33,5Z"
                                            fill="#rrrr" fillRule="evenodd"/>
                                        <path
                                            d="M11,5.24A5.76,5.76,0,1,0,16.76,11,5.76,5.76,0,0,0,11,5.24Zm0,9.43h0a3.67,3.67,0,0,1-.17-7.34H11a3.67,3.67,0,0,1,0,7.34Z"
                                            fill="#rrrr" fillRule="evenodd"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="footer-love w-100 text-center">
                        <span className="text-center">Made in London 🇬🇧 with ❤️</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="d-flex justify-content-center align-items-center">
                            <span>Powered By </span>
                            <div>
                                <img src={PoweredBy} height="160" />
                            </div>
                        </div>
                    </div>

                </div>
            </footer>


        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js